__turbopack_context__.v({
  "Category": "FeaturePost-module-sass-module__jDEMBa__Category",
  "Cont": "FeaturePost-module-sass-module__jDEMBa__Cont",
  "Content": "FeaturePost-module-sass-module__jDEMBa__Content",
  "ContentInner": "FeaturePost-module-sass-module__jDEMBa__ContentInner",
  "FeaturePost": "FeaturePost-module-sass-module__jDEMBa__FeaturePost",
  "Image": "FeaturePost-module-sass-module__jDEMBa__Image",
  "Title": "FeaturePost-module-sass-module__jDEMBa__Title",
});
